import config from "@/config"
import http from "@/utils/request"
export default{
    
    oneClickAlarm: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/XHW1BasicData/`,
        name: "一键报警",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    
    setMute: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/soundSize/`,
        name: "设置声音大小",
        post: async function (id, val) {
            return await http.post(this.url + id, { size : val});
        }
    },

    setSound: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/silentMode/`,
        name: "设置静音模式",
        post: async function (id, val) {
            return await http.post(this.url + id, { state: val });
        }
    },

    setPosit: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/positioningPriority/`,
        name: "设置定位优先级",
        post: async function (id, val) {
            return await http.post(this.url + id, { priority: val });
        }
    },

    setGnss: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/GnssSwitch/`,
        name: "设置GNSS开关",
        post: async function (id, val) {
            return await http.post(this.url + id, { locationMode: val });
        }
    },

    default: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/restoreFactorySettings/`,
        name: "恢复出厂设置",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    upOTA: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/upgradeOTA/`,
        name: "OTA升级",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    playBell: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/playRingtone/`,
        name: "播放铃声",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    sosPhone: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/XHW1PhoneData/`,
        name: "查询一键报警(SOS)号码",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    callLog: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/XhW1CallLog/`,
        name: "查询SOS通话记录",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    locationLog: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/XhW1LocateLog/`,
        name: "查询定位坐标记录",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        }
    },

    setPhone: {
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/phoneNumber/`,
        name: "下发设置号码",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        }
    },

    setWhieListModel:{
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/whiteListModel/`,
        name: "修改白名单模式",
        post: async function (id, data) {
            return await http.post(this.url + id, {State: data});
        }
    },

    setVoiceModel:{
        url: `${config.API_URL}/oneClickAlarmSOSUniversal/voiceMode/`,
        name: "修改语音模式",
        post: async function (id, data) {
            return await http.post(this.url + id, {State: data});
        }
    }
}